<template>
  <price-calculation-row
    :label="label"
    :unit="unit"
    :amount="item.amount"
    :unit-price="item.tariff"
    :total-price="item.total"
  />
</template>

<script>
import PriceCalculationRow from './PriceCalculationRow.vue';

export default {
  components: {
    PriceCalculationRow,
  },
  props: [
    'item',
    'unit',
  ],
  computed: {
    label() {
      let { unit } = this;
      if (unit === 'm<sup>3</sup>') {
        unit = 'm³';
      }

      const unitSpecification = `${this.item.from}-${this.item.to} ${unit}`;

      switch (this.item.type) {
        case 'usage':
          if (this.item.from > 1) {
            return `Verbruikskosten ${unitSpecification}`;
          }
          return 'Verbruikskosten';
        case 'usage_single':
          if (this.item.from > 1) {
            return `Verbruikskosten (enkel) ${unitSpecification}`;
          }
          return 'Verbruikskosten (enkel)';
        case 'usage_normal':
          if (this.item.from > 1) {
            return `Verbruikskosten (normaal) ${unitSpecification}`;
          }
          return 'Verbruikskosten (normaal)';
        case 'usage_offpeak':
          if (this.item.from > 1) {
            return `Verbruikskosten (dal) ${unitSpecification}`;
          }
          return 'Verbruikskosten (dal)';
        case 'settling_single':
          return 'Salderen';
        case 'settling_normal':
          return 'Salderen (normaal)';
        case 'settling_offpeak':
          return 'Salderen (dal)';
        case 'feed_in':
          return 'Terugleveren';
        case 'feed_in_normal':
          return 'Terugleveren (normaal)';
        case 'feed_in_offpeak':
          return 'Terugleveren (dal)';
        case 'price_cap_gas':
          return 'Verbruikskosten (prijsplafond)';
        case 'price_cap_electricity_single':
          return 'Verbruikskosten (prijsplafond)';
        case 'price_cap_electricity_normal':
          return 'Verbruikskosten (prijsplafond, normaal)';
        case 'price_cap_electricity_offpeak':
          return 'Verbruikskosten (prijsplafond, dal)';
        case 'settling_price_cap':
          return 'Salderen (prijsplafond)';
        case 'average_market_tariff':
          return 'Verwachte inkoopprijs';
        case 'purchase_costs':
          return 'Inkoopvergoeding';
        case 'purchase_costs_settling':
          return 'Inkoopvergoeding (salderen)';
        case 'purchase_costs_feedin':
          return 'Inkoopvergoeding (terugleveren)';
        case 'feedin_costs_fixed':
          return 'Terugleverkosten';
        case 'feedin_costs_kwh':
          return 'Terugleverkosten per kWh';
        case 'tax+ode':
          if (this.item.to === 0 || this.item.to < 10000 || this.unit !== 'kWh') {
            return 'Overheidsheffingen';
          }

          let unit = this.unit;
          if (unit === 'm<sup>3</sup>') {
            unit = 'm³';
          }
          return `Overheidsheffingen ${this.item.from}-${this.item.to} ${unit}`;

        // For future use:
        case 'fixed_costs':
          return 'Vastrecht';
        case 'distribution_costs':
          return 'Netbeheerkosten';
        case 'tax_discount':
          return 'Vermindering energiebelasting';

        // Fallback for unknown types
        default:
          return this.item.type;
      }
    },
  }
}
</script>

<style scoped>

</style>
